import type { JSX } from 'react'

import { DownloadsList } from 'containers/DownloadsList'
import { BoxFormLayout } from 'layouts/BoxFormLayout'

export const DownloadScreen = (): JSX.Element => (
  <BoxFormLayout>
    <DownloadsList />
  </BoxFormLayout>
)
